
 import { HexToRGB } from '~/utils/utils.js'
export default {
  props: {
    companyBasic: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.onresize = () => {
        this.$forceUpdate()
      }
    })
    console.log('企业基础信息', this.companyBasic)
  },
  methods: {
    TransColor(color, tm) {
      if (!color) {
        return ''
      } else {
        return HexToRGB(color, tm)
      }
    },
    GoToCompany(info) {
      if (this.companyBasic?.companyId ) {
        const link = `/${this.$store.state.LanguageCode}/company/${this.companyBasic?.companyId}.html`
        window.open(link)
      }
    },
  }
}
